// extracted by mini-css-extract-plugin
module.exports = {"container":"akk_e","imageContainer":"akk_be","textContainer":"akk_l1","title":"akk_eg"};